import { useEffect, useState } from 'react';
import EmoteIcon from '../../Components/EmoteIcon';
import { EMOTE_DISPLAY_MS } from './EmoteWheel';

export type SeatEmoteBurstProps = {
  emoteId?: string | null;
  at?: number | null;
  className?: string;
};

/** Brief floating emote when a seat broadcasts recentEmote. */
export default function SeatEmoteBurst({
  emoteId,
  at,
  className = '',
}: SeatEmoteBurstProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!emoteId || !at) {
      setVisible(false);
      return;
    }
    const age = Date.now() - Number(at);
    if (age > EMOTE_DISPLAY_MS) {
      setVisible(false);
      return;
    }
    setVisible(true);
    const left = EMOTE_DISPLAY_MS - age;
    const id = window.setTimeout(() => setVisible(false), left);
    return () => window.clearTimeout(id);
  }, [emoteId, at]);

  if (!visible || !emoteId) return null;

  return (
    <span
      className={[
        'pointer-events-none absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2',
        className,
      ].join(' ')}
    >
      <EmoteIcon emoteId={emoteId} size="lg" className="shadow-lg" />
    </span>
  );
}
